import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    loggedIn: false,
    userId: "",
    firstName: "",
    lastName: "",
    userName: "",
    theme: "light",
    trinDocsLicenseLevel: "",
    trinFormsLicenseLevel: "",
    jwtToken: "",
    tdVersion: "",
    permissions: [],
    expiredToken: false,
    errorMessage: "",
    currentApp: 1,
    delegateList: [],
    activeUser: {
      userId: 0,
      userName: ""
    },
    userSettings: [],
    email: "",
    loginError: ""
  }
};
const loginInfoSlice = createSlice({
  name: "loginInfo",
  initialState,
  reducers: {
    logout: (state) => {
      console.log("logout");
      localStorage.setItem("td6Token", "");
      document.cookie = "td6Token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      state.value = {
        loggedIn: false,
        firstName: "",
        lastName: "",
        userName: "",
        userId: "",
        theme: "light",
        loginError: ""
      };
      window.location = "/";
    },
    login: (state, action) => {
      state.value = {
        loggedIn: true,
        userId: action.payload.userId,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        userName: action.payload.userName,
        theme: action.payload.theme,
        trinDocsLicenseLevel: action.payload.licenseLevel,
        trinFormsLicenseLevel: action.payload.trinFormsLicenseLevel,
        //currentApp: currentApp,
        jwtToken: action.payload.jwtToken,
        tdVersion: action.payload.tdVersion,
        permissions: action.payload.permissions,
        expiredToken: action.payload.expiredToken,
        delegateList: action.payload.delegates,
        activeUser: {
          userId: action.payload.userId,
          userName: action.payload.userName
        },
        userSettings: action.payload.userSettings,
        email: action.payload.email
        //expiredToken: action.payload.expiredToken,
        //delegateList: action.payload.delegates,
        //activeUser: {
        //    userId: action.payload.userId,
        //    userName: action.payload.userName
        //},
        //userSettings: action.payload.userSettings,
        //email: action.payload.email
      };
      window.localStorage.setItem("td6Token", action.payload.jwtToken);
    },
    loginFail: (state, action) => {
      console.log(action.payload);
      state.value = {
        loggedIn: false,
        firstName: "",
        lastName: "",
        userName: "",
        trinDocsLicenseLevel: 0,
        trinFormsLicenseLevel: 0,
        jwtToken: "",
        tdVersion: action.payload.tdVersion,
        permissions: [],
        expiredToken: action.payload.expiredToken,
        errorMessage: action.payload.message,
        delegateList: [],
        activeUser: {
          userId: 0,
          userName: ""
        },
        userSettings: [],
        email: "",
        currentApp: 1
      };
    }
    // switchToTrinForms: (state, action) => {
    //     let s = {...state.value};
    //     s.activeUser = {
    //         userId: s.userId,
    //         userName: s.userName
    //     }
    //     s.currentApp = 2;
    //     state.value = s;
    // },
    // switchToTrinDocs: (state, action) => {
    //     let s = {...state.value};
    //     s.activeUser = {
    //         userId: s.userId,
    //         userName: s.userName
    //     }
    //     s.currentApp = 1;
    //     state.value = s;
    // }
  }
});
export const { logout, login, loginFail } = loginInfoSlice.actions;
export default loginInfoSlice.reducer;
